export const  NfseModel = {
  OS: "os",
  NFSE: "nfse",
}